import * as IconSelector from '../icons';

// Constantes exportadas
export const USE_PARCEL_CONSUMO = 'Consumo';
export const USE_PARCEL_DERRAMA = 'Derrama';

// Definición del enum
export const useParcel = [
    {
        value: USE_PARCEL_CONSUMO,
        label: 'Consumo',
        description: 'Se utiliza para consumo de agua',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: USE_PARCEL_DERRAMA,
        label: 'Derrama',
        description: 'Se utiliza para Derramas',
        icon: IconSelector.PointIcon,
        color: 'Green'
    }
];
